import Colors from "../../core/Colors";
import { ComponentF } from "../ui";
import { withColor } from "../uiText";
import { handleKeyOnClick } from "./keyOnClick";

export const TextButton: ComponentF<{
  disabled?: boolean;
  title: string;
  keyLabel: string;
  keys: string | string[];
  onClick: () => void;
}> = (C, props) => {
  const [state, setState] = C.useState({ hover: false });
  C.display.drawText(
    C.bounds.x,
    C.bounds.y,
    `${withColor(
      props.disabled
        ? Colors.GRAY_2
        : state.hover
        ? Colors.GREEN_4
        : Colors.GREEN_3,
      props.keyLabel
    )} ${withColor(
      props.disabled
        ? Colors.GRAY_2
        : state.hover
        ? Colors.WHITE
        : Colors.EGGSHELL,
      props.title
    )}`
  );

  if (!props.disabled) {
    C.handlers.hover = () => {
      setState({ hover: true });
    };

    C.handlers.out = () => {
      setState({ hover: false });
    };

    C.handlers.press = () => {
      props.onClick();
    };
  }

  handleKeyOnClick(C, props);
};
